import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';
import Button from '@material-ui/core/Button';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import { isMobile } from '../../utils';
import Menu from './Menu/Menu';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { Typography, Grid, Hidden } from '@material-ui/core';
import ToggleAudioButton from '../Buttons/ToggleAudioButton/ToggleAudioButton';
import ToggleChatButton from '../Buttons/ToggleChatButton/ToggleChatButton';
import ToggleParticipantWindowButton from '../Buttons/ToggleParticipantWindowButton/ToggleParticipantWindowButton';
import ToggleVideoButton from '../Buttons/ToggleVideoButton/ToggleVideoButton';
import ToggleScreenShareButton from '../Buttons/ToogleScreenShareButton/ToggleScreenShareButton';
import { useAppState } from '../../state';
import InviteDialog from '../InviteDialog/InviteDialog';
import FilesDialog from '../FilesDialog/FilesDialog';
import FilesIcon from '../../icons/FilesIcon';
import GuestsDialog from '../GuestsDialog/GuestsDialog';
import RaiseHandButton from '../Buttons/RaiseHandButton/RaiseHandButton';
import { PersonAdd } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      bottom: 0,
      left: 0,
      right: 0,
      height: `${theme.footerHeight}px`,
      position: 'fixed',
      display: 'flex',
      padding: '0 1.43em',
      zIndex: 10,
      [theme.breakpoints.down('sm')]: {
        height: `${theme.mobileFooterHeight}px`,
        padding: 0,
      },
    },
    screenShareBanner: {
      position: 'fixed',
      zIndex: 8,
      bottom: `${theme.footerHeight}px`,
      left: 0,
      right: 0,
      height: '104px',
      background: 'rgba(0, 0, 0, 0.5)',
      '& h6': {
        color: 'white',
      },
      '& button': {
        background: 'white',
        color: theme.brand,
        border: `2px solid ${theme.brand}`,
        margin: '0 2em',
        '&:hover': {
          color: '#600101',
          border: `2px solid #600101`,
          background: '#FFE9E7',
        },
      },
    },
    hideMobile: {
      display: 'initial',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  })
);

export default function MenuBar() {
  const classes = useStyles();
  const { isSharingScreen, toggleScreenShare } = useVideoContext();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const { user } = useAppState();
  const participants = useParticipants();
  const [inviteOpen, setInviteOpen] = useState(false);
  const [filesOpen, setFilesOpen] = useState(false);
  const [guestsOpen, setGuestsOpen] = useState(false);

  const inviteButton = !user?.isMuted && (
    <Tooltip title="Meghivás">
      <Button onClick={() => setInviteOpen(!inviteOpen)}>
        <EmailIcon />
      </Button>
    </Tooltip>
  );
  const guestsButton = !user?.isMuted && (
    <Tooltip title="Vendégek">
      <Button onClick={() => setGuestsOpen(!guestsOpen)}>
        <PersonAdd />
      </Button>
    </Tooltip>
  );
  // @ts-ignore
  // eslint-disable-next-line eqeqeq
  const invite = user?.isAdmin == 1 ? inviteButton : '';

  // @ts-ignore
  // eslint-disable-next-line eqeqeq
  const files = !user?.isMuted && (
    <Tooltip title="Megosztott állományok">
      <Button onClick={() => setFilesOpen(!filesOpen)}>
        <FilesIcon />
      </Button>
    </Tooltip>
  );

  // @ts-ignore
  // eslint-disable-next-line eqeqeq
  const guests = user?.isMod == 1 ? guestsButton : '';

  return (
    <>
      <InviteDialog
        open={inviteOpen}
        onClose={() => {
          setInviteOpen(false);
        }}
      />
      <FilesDialog
        open={filesOpen}
        onClose={() => {
          setFilesOpen(false);
        }}
      />
      <GuestsDialog
        open={guestsOpen}
        onClose={() => {
          setGuestsOpen(false);
        }}
      />
      {isSharingScreen && (
        <Grid container justifyContent="center" alignItems="center" className={classes.screenShareBanner}>
          <Typography variant="h6">A képernyő megosztás fut</Typography>
          <Button onClick={() => toggleScreenShare()}>Leállítás</Button>
        </Grid>
      )}
      <footer className={classes.container}>
        <Grid container justifyContent="space-around" alignItems="center">
          <Hidden smDown>
            <Grid style={{ flex: 1 }}>
              <Typography variant="body1">
                {user!.roomName} ({participants.length + 1} résztvevő{participants.length ? 'k' : ''})
              </Typography>
            </Grid>
          </Hidden>
          <Grid item>
            <Grid container justifyContent="center">
              {!user?.isMuted && <ToggleAudioButton disabled={isReconnecting} />}
              {!user?.isMuted && <ToggleVideoButton disabled={isReconnecting} />}
              {!isSharingScreen && !user?.isMuted && !isMobile && <ToggleScreenShareButton disabled={isReconnecting} />}
              {!user?.isMuted && process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && <ToggleChatButton />}
              <ToggleParticipantWindowButton />
              <Hidden smDown>
                <Menu />
              </Hidden>
              {invite}
              {files}
              {guests}
              <RaiseHandButton />
              <EndCallButton />
            </Grid>
          </Grid>
          <Hidden smDown>
            <Grid style={{ flex: 1 }}>
              <Grid container justifyContent="flex-end"></Grid>
            </Grid>
          </Hidden>
        </Grid>
      </footer>
    </>
  );
}
